<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Fungsi</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th style="width: 5%">No.</th>
                            <th style="width: 20%">Kode Fungsi</th>
                            <th style="width: 40%">Nama Fungsi</th>
                            <th style="width: 15%">Pilihan</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="h_isitable" v-for="(data,index) in list_fungsi" :key="data.fungsi_id">
                            <td>{{index+1}}</td>
                            <td>{{data.kode_fungsi}}</td>
                            <td>{{data.nama}}</td>
                            <td class="tabel_center text-center" >
                                <button @click="selectDataLink(data.fungsi_id)" class="btn bg-indigo btn-xs waves-effect" title="Tambah SATKER" id="t_satker" data-toggle="modal" data-target="#m_tambah_bidang">
                                    <i class="material-icons" >add_to_photos</i>
                                </button>
                                &nbsp; 
                                <button @click="selectData(data.kode_fungsi, data.nama, data.fungsi_id)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                    <i class="material-icons" >create</i>
                                </button>
                                &nbsp; 
                                <button @click="removeData(data.fungsi_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                    <i class="material-icons" >clear</i>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>

                      <span style="font-size: 85%; color: #a5a5a5"><b>1 - 1</b></span>

                      <button type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>
                <!-- ============================================================ MODAL ======================================================================== -->
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                                <form @submit.prevent="addData()">
                                <div class="modal-body">

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Kode Fungsi</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="data.kode" type="text" class="form-control" placeholder="Ex : 01">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Fungsi</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="data.nama" type="text" class="form-control" placeholder="Ex : Pelayanan Umum">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                                </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL Bidang xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_bidang" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-indigo">
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="row ">
                                        <div class="col-md-12 text-right">
                                            <button @click="triggerPerma()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data_satker"><i class="material-icons">add</i></button> 
                                            <br>
                                        </div>
                                    </div>


                                <div class="row clearfix">
                                <br>
                                <div class="table-responsive">
                                    <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                        <tr class="bg-info">
                                            <th style="width: 5%">No.</th>
                                            <th style="width: 30%">Kode Bidang</th>
                                            <th style="width: 30%">Nama Bidang</th>
                                
                                            <th style="width: 10%">#</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr class="h_isitable" v-for="(data,index) in list_fungsi_relate" :key="data.relasi_id">
                                            <td>{{index+1}}</td>
                                            <td>{{data.kode_bidang}}</td>
                                            <td>{{data.nama_bidang}}</td>
                                        
                                            <td class="text-center" >
                                                
                                                <button @click="removeDataRelate(data.relasi_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                    <i class="material-icons" >clear</i>
                                                </button>


                                            </td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>
                                </div>


                                </div>
                                <div class="modal-footer">
                                    <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL SATKER xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Kode Fungsi</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="kode" type="text" class="form-control" placeholder="Ex : 01">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Fungsi</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="nama" type="text" class="form-control" placeholder="Ex : Pelayanan Umum">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                </div>

                                <div class="modal-footer">
                                    <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_tambah_data_bidang xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data_satker" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA </h4>
                                </div>
                        <form @submit.prevent="addDataPerma()">
                                <div class="modal-body">

                                                    <div class="row paddingku">
                                <div class="col-md-3 searching">
                                    <span class="h_page">Bidang Urusan Pemerintahan</span> <br> <br>
                                </div>
                            </div>

                                <div class="row clearfix">

                                <div class="table-responsive">
                                    <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                        <tr class="bg-info">
                                            <th style="width: 5%">No.</th>
                                            <th style="width: 30%">Kode Bidang</th>
                                            <th style="width: 30%">Nama Bidang</th>
                                
                                            <th style="width: 10%">#</th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        <tr class="h_isitable" v-for="(data,index) in list_permasalahan" :key="data.skpd_id">
                                            <td>{{index+1}}</td>
                                            <td>{{data.kode_bidang}}</td>
                                            <td>{{data.nama_bidang}}</td>
                                            <td>
                                                <input type="hidden" v-model="dataPerma._id" >
                                                <div class="demo-checkbox">
                                                    <input type="checkbox" @click="addtoArray(data.bidang_urusan_pemerintahan_id)" v-bind:id="data.bidang_urusan_pemerintahan_id"/>
                                                    <label v-bind:for="data.bidang_urusan_pemerintahan_id"></label>
                                                </div>
                                            </td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>
                                </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>

                        </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_tambah_data_bidang xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_fungsi/';
    const ADD_URL_Perma = URL_APP+'api/v1/planning_bidang/';


    export default {
    name: "monev_kabupaten",
    data() {
        return {
            data:{
                kode: '',
                nama: '',
            },
            dataPerma:{
                _id: '',
                _id_array: [],
            },
            _id: '',
            kode: '',
            nama: '',
            list_fungsi: [],
            list_permasalahan: [],
            list_fungsi_relate: [],
            page_last: '',
        };
    },

    // =============================================================== METHODS =========================================================================
    methods : {
        addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then(res => res.json()).then((data_urusan) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
        },
        selectDataLink : function(a){
            this.dataPerma._id = a;
            this.getDataFungsiandBidang();
        },
        triggerPerma: function (){
            this.getDataPerma();
            this.dataPerma._id_array = [] ;  
        },
        getData: function(){
            fetch(ADD_URL+'readData', {
                method : 'POST',
                headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    data_ke : this.page_first,
                    cari_value : this.cari_value
                })
            }).then((res) => res.json()).then((data_urusan) => {
                this.list_fungsi = data_urusan.data;
                this.page_last = data_urusan.jml_data;
            })
        },
        addtoArray: function(a){
            let cb = document.getElementById(a).checked

            if (cb == true){
                this.dataPerma._id_array.push(a);
            } else {
                this.dataPerma._id_array.pop(a);
            }
            console.log(JSON.stringify(this.dataPerma));
        },
        addDataPerma: function(){
                console.log(JSON.stringify(this.dataPerma));
                fetch(ADD_URL_Perma+'addDataLinkPerma', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.dataPerma)
                }).then(res => res.json()).then((data_bidang) => {
                    // console.log(data_bidang);
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getDataPerma();
                    this.getDataFungsiandBidang();
                });
        },
        getDataFungsiandBidang: function(){
                fetch(ADD_URL_Perma+'readDataLinkFungsiBidang', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      id : this.dataPerma._id,
                    })
                }).then((res) => res.json()).then((data_urusan) => {
                  this.list_fungsi_relate = data_urusan.data;
                })
        },
        getDataPerma: function(){
            fetch(ADD_URL_Perma+'readDataLinkFungsi', {
                method : 'POST',
                headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    id : this.dataPerma._id,
                    data_ke : this.page_first,
                    cari_value : this.cari_value
                })
            }).then((res) => res.json()).then((data_urusan) => {
                this.list_permasalahan = data_urusan.data;
            })
        },
        editData: function(){
            fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        kode: this.kode,
                        nama: this.nama,
                        _id : this._id,
                    })
            }).then((res_data) => {
                this.alertku("success", "Berhasil Mengubah Data!");
                this.getData();
            });      
        },
        selectData : function(a, b, c){
            this.kode = a;
            this.nama = b;
            this._id = c;
        },
        removeData: function(id){
            this.$swal({
                title: 'Apa Anda Ingin Menghapus Data?',
                text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
                if(result.value) {
                fetch(ADD_URL+"deleteData", {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                    },
                    body : JSON.stringify({
                        id : id,
                    })
                }).then(()=>{
                    this.alertku("success", "Sukses Menghapus Data!");
                    this.getData();
                });
                this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                } else {
                this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                }
            })
        },
        removeDataRelate : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL_Perma+"deleteDataRelate", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getDataFungsiandBidang();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
        },
        alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
        },
    },
    // =============================================================== METHODS =========================================================================

    mounted() {
        this.getData();
        localStorage.sidemenu = 'planing';
    },
    };
</script>
